export default __webpack_public_path__ + "static/media/Transamerica.5aee89c9.svg";